export default "__VITE_ASSET__BjjIsYRl__"